import { AttendContactLateFactory } from './attendContactLateFactory';

import type {
  AttendContactLateEntity,
  AttendContactLatePropsPub,
  AttendContactLatePropsPvt,
} from './attendContactLateEntity';
import type { AttendContactLateIRepository } from './attendContactLateIRepository';
import type { EntityDataPubType } from '@/infra/appsync';
import type { AttendContactLateJsonPub, AttendContactLateJsonPvt } from '@/types/domain/attendContact/entities/attendContactLateEntity';

import { AppsyncRepository } from '@/domain/appsyncRepository';
import {
  EntityName,
} from '@/infra/appsync';

export class AttendContactLateRepository extends AppsyncRepository<
  AttendContactLateEntity,
  AttendContactLatePropsPvt,
  AttendContactLateJsonPvt,
  AttendContactLatePropsPub,
  AttendContactLateJsonPub
> implements AttendContactLateIRepository {
  private factory = new AttendContactLateFactory();

  protected get entityName(): EntityName {
    const name: EntityName = EntityName.WagakoNurseryAttendContactAttendContactLateEntity;
    return name;
  }

  /**
   * DBデータをEntityに変換
   * @param props DBデータ
   * @returns Entity
   */
  protected createFromEntityType = (
    props: EntityDataPubType,
  ) => this.factory.createFromEntityType(props);
}
